import { render, staticRenderFns } from "./SmartTouchMaintenance.vue?vue&type=template&id=125b15a4"
import script from "./SmartTouchMaintenance.vue?vue&type=script&lang=js"
export * from "./SmartTouchMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports